import apiInstance from '../services/apiInstance';

export const useImageActions = () => {
    const fetchCompressedImages = async () => {
        const response = await apiInstance.get('/images-compress');
        return response.data;
    };

    const uploadImage = async (formData: FormData, onUploadProgress?: (progressEvent: any) => void) => {
        const response = await apiInstance.post('/uploader', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: onUploadProgress,
        });
        return response.data;
    };

    const downloadImage = async (id: number) => {
        const response = await apiInstance.get(`/download/${id}`, {
            responseType: 'blob',
        });
        return response.data;
    };

    return { fetchCompressedImages, uploadImage, downloadImage };
};
